import React from "react";

function CrossIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.476 16.9076V13.3603H7.03003C6.31391 13.3603 5.73779 12.7672 5.73779 12.0301C5.73779 11.2929 6.31391 10.6998 7.03003 10.6998H10.476V7.15251C10.476 6.41533 11.0521 5.82227 11.7682 5.82227C12.4843 5.82227 13.0605 6.41533 13.0605 7.15251V10.6998H16.5064C17.2225 10.6998 17.7987 11.2929 17.7987 12.0301C17.7987 12.7672 17.2225 13.3603 16.5064 13.3603H13.0605V16.9076C13.0605 17.6448 12.4843 18.2379 11.7682 18.2379C11.0521 18.2379 10.476 17.6448 10.476 16.9076Z"
        fill="white"
      />
    </svg>
  );
}

export default CrossIcon;
